import { useState, useEffect, useCallback } from 'react';
import '../styles/gameboy.css';

const GameBoy = ({
  children,
  onAPress,
  onBPress,
  onUpPress,
  onDownPress,
  onSelectPress,
  onStartPress,
  onPowerToggle,
  onPowerOff,
}) => {
  const [powerOn, setPowerOn] = useState(true);

  const handlePowerClick = () => {
    if (powerOn) {
      // Turn off
      setPowerOn(false);
      onPowerOff?.(); // Notify parent that power is off
    } else {
      // Turn back on - restart
      setPowerOn(true);
      onPowerToggle?.();
    }
  };
  // Keyboard support
  const handleKeyDown = useCallback((e) => {
    // Check if user is typing in an input field
    const isTypingInInput = ['INPUT', 'TEXTAREA'].includes(e.target.tagName);

    switch (e.key) {
      case 'Enter':
        // Allow Enter to submit forms, but also trigger A
        if (!isTypingInInput) {
          e.preventDefault();
        }
        onAPress?.();
        break;
      case ' ':
        if (!isTypingInInput) {
          e.preventDefault();
          onAPress?.();
        }
        break;
      case 'Escape':
        e.preventDefault();
        onBPress?.();
        break;
      case 'Backspace':
        // Only trigger B if not in an input field
        if (!isTypingInInput) {
          e.preventDefault();
          onBPress?.();
        }
        break;
      case 'ArrowUp':
        if (!isTypingInInput) {
          e.preventDefault();
          onUpPress?.();
        }
        break;
      case 'ArrowDown':
        if (!isTypingInInput) {
          e.preventDefault();
          onDownPress?.();
        }
        break;
      case 's':
        if (!isTypingInInput) {
          onSelectPress?.();
        }
        break;
      default:
        break;
    }
  }, [onAPress, onBPress, onUpPress, onDownPress, onSelectPress]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className="gameboy-root">
      <div className="gameboy-outer">
        {/* Screen */}
        <div className="gameboy-screen-outer">
          <div className="gameboy-power-row">
            <div className={`gameboy-power-light ${powerOn ? 'on' : 'off'}`} />
            <span className="gameboy-power-text" onClick={handlePowerClick} style={{ cursor: 'pointer' }}>POWER</span>
          </div>
          <div className="gameboy-screen-wrapper">
            <div className={`gameboy-screen-inner ${!powerOn ? 'power-off' : ''}`}>
              {powerOn ? children : null}
            </div>
          </div>
        </div>

        {/* Controls */}
        <div className="gameboy-controls">
          {/* SELECT / START */}
          <div className="gameboy-menu-row">
            <div className="gameboy-select-start" onClick={onSelectPress}>
              <div className="gameboy-ss-line" />
              <span className="gameboy-ss-text">SELECT</span>
            </div>
            <div className="gameboy-select-start" onClick={onStartPress}>
              <div className="gameboy-ss-line" />
              <span className="gameboy-ss-text">START</span>
            </div>
          </div>

          {/* D-Pad and A/B */}
          <div className="gameboy-controls-row">
            {/* D-Pad */}
            <div className="gameboy-dpad">
              <div className="gameboy-dpad-vertical" />
              <div className="gameboy-dpad-horizontal" />
              <button className="gameboy-dpad-btn gameboy-dpad-up" onClick={onUpPress} />
              <button className="gameboy-dpad-btn gameboy-dpad-down" onClick={onDownPress} />
              <button className="gameboy-dpad-btn gameboy-dpad-left" />
              <button className="gameboy-dpad-btn gameboy-dpad-right" />
            </div>

            {/* A/B Buttons */}
            <div className="gameboy-ab">
              <button className="gameboy-btn gameboy-btn-a" onClick={onAPress}>A</button>
              <button className="gameboy-btn gameboy-btn-b" onClick={onBPress}>B</button>
            </div>
          </div>

          {/* Speaker */}
          <div className="gameboy-speaker">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="gameboy-speaker-line" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameBoy;
